import { render, staticRenderFns } from "./RegistrationFormJoin.vue?vue&type=template&id=851ad57c&"
import script from "./RegistrationFormJoin.vue?vue&type=script&lang=js&"
export * from "./RegistrationFormJoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports